import type {ErrorResponse} from '@nuxtjs/apollo'
import {loadDevMessages, loadErrorMessages} from "@apollo/client/dev";
import {useLogger} from "~/utils/logger";

export default defineNuxtPlugin((nuxtApp) => {
  const logger = useLogger('apollo')

  nuxtApp.hook('apollo:auth', ({client, token}) => {
    const {tokenUtils} = useAuth()
    const store = useAppStore()
    if (store.currentStore) {
      token.value = store.currentStore.id ? tokenUtils.getToken(store.currentStore.id) : null
    }
  })

  // Nuxt Apollo error hook
  nuxtApp.hook('apollo:error', (error: ErrorResponse) => {
    // eslint-disable-next-line no-console
    logger.error('Apollo Error Handler', error)
  })
  if (import.meta.env.DEV) {
    // Adds messages only in a dev environment
    loadDevMessages()
    loadErrorMessages()
  }
})
